import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const elementAnalysis = {
    jpath: ['spectra', 'elementalAnalysis'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default elementAnalysis;
//# sourceMappingURL=elementAnalysis.js.map